import React, { useMemo, useCallback } from 'react';

import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';

import { noop } from 'ui-components/default-props/noop';

import AdvancedHotkey from './component';
import { RateBrowserDefaultsPropType } from '../../../prop-types/rate-browser-defaults';
import { openRateBrowserModal } from '../../../store/rate-browser/rate-browser.actions';
import { useTrackRateBrowser } from '../../rate-viewer/use-track-rate-browser';
import { WorkflowSteps } from '../../../tracking/use-workflow-tracking';
import { EventSourceStrings } from '../../../tracking/tracking-constants';
import { emptyObject } from 'ui-components/default-props/empty';

export const messages = defineMessages({
  name: {
    description: 'open rate calculator hotkey',
    defaultMessage: 'Show Rate Calculator',
    id: 'Fc6CUm',
  },
});

export const hotkey = ['c'];
export const barcodeContent = '+5EAZWXHNA6WK=';

const OpenRateBrowserHotkey = ({
  children,
  isOnOrderDetails = false,
  fulfillmentPlanId,
  onLaunchRateBrowserFromOrderDetails = noop,
  rateBrowserDefaults = emptyObject,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const trackRateBrowser = useTrackRateBrowser();

  const onUpdate = useCallback(() => {
    if (isOnOrderDetails && fulfillmentPlanId) {
      onLaunchRateBrowserFromOrderDetails();
      trackRateBrowser(WorkflowSteps.START, {
        source: EventSourceStrings.ORDER_DETAILS_HOT_KEY,
      });
      return;
    }

    dispatch(openRateBrowserModal(rateBrowserDefaults));
    trackRateBrowser(WorkflowSteps.START, {
      source: EventSourceStrings.GRID_HOT_KEY,
    });
  }, [isOnOrderDetails, fulfillmentPlanId, dispatch, rateBrowserDefaults, trackRateBrowser, onLaunchRateBrowserFromOrderDetails]);

  const hotkeyMetadata = useMemo(
    () => ({
      barcode: barcodeContent,
      displayHotkeyStrings: hotkey,
      hotkey,
      handler: onUpdate,
      name: intl.formatMessage(messages.name),
      legacyCategory: 'general',
      doNotTrack: true,
    }),
    [intl, onUpdate],
  );

  return <AdvancedHotkey hotkey={hotkeyMetadata}>{children}</AdvancedHotkey>;
};

OpenRateBrowserHotkey.propTypes = {
  children: PropTypes.node.isRequired,
  isOnOrderDetails: PropTypes.bool,
  fulfillmentPlanId: PropTypes.string,
  onLaunchRateBrowserFromOrderDetails: PropTypes.func,
  rateBrowserDefaults: RateBrowserDefaultsPropType,
};

export default OpenRateBrowserHotkey;
